export const scope = 'containers.component.postSignup';

export const postSignUpMessages = {
  keepTrackSavedSearch: {
    id: `${scope}.keepTrackSavedSearch`,
    defaultMessage: 'Keep track of this saved search',
  },
  keepTrack: {
    id: `${scope}.keepTrack`,
    defaultMessage: 'Keep track of your dealer enquires by signing up to your heycar account',
  },
  getRecommendations: {
    id: `${scope}.getRecommendations`,
    defaultMessage: 'Get recommendations',
  },
  viewSavedSearch: {
    id: `${scope}.viewSavedSearch`,
    defaultMessage: 'View saved search',
  },
  trackDealerEnquiries: {
    id: `${scope}.trackDealerEnquiries`,
    defaultMessage: 'Track dealer enquiries',
  },
  accountSignup: {
    id: `${scope}.accountSignup`,
    defaultMessage: 'Sign up now',
  },
};
